export default __webpack_public_path__ + "static/media/page-decoration-3.20ec074f.svg";